import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Home, 
  Search,
  AlertCircle,
  MoveLeft
} from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4 animate-fade-in
      bg-light-surface dark:bg-dark-surface">
      <div className="max-w-2xl w-full space-y-8 text-center">
        {/* Icona e Titolo */}
        <div className="space-y-4">
          <div className="flex justify-center">
            <AlertCircle 
              size={64} 
              className="text-light-tertiary dark:text-dark-tertiary"
            />
          </div>
          <h1 className="text-6xl font-bold 
            text-light-on-surface dark:text-dark-on-surface">
            404
          </h1>
          <h2 className="text-2xl font-medium
            text-light-on-surface-variant dark:text-dark-on-surface-variant">
            Pagina non trovata
          </h2>
        </div>

        {/* Messaggio */}
        <p className="text-lg 
          text-light-on-surface-variant dark:text-dark-on-surface-variant">
          La pagina che stai cercando potrebbe essere stata spostata, eliminata o potrebbe non essere mai esistita.
        </p>

        {/* Pulsanti */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          {/* Pulsante Home */}
          <Link 
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg
              bg-light-primary dark:bg-dark-primary 
              text-light-on-primary dark:text-dark-on-primary
              hover:bg-light-primary-container dark:hover:bg-dark-primary-container
              transition-colors duration-200">
            <Home size={20} />
            <span>Torna alla Home</span>
          </Link>

          {/* Pulsante Indietro */}
          <button 
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg
              border border-light-outline dark:border-dark-outline
              text-light-on-surface dark:text-dark-on-surface
              hover:bg-light-surface-bright dark:hover:bg-dark-surface-bright
              transition-colors duration-200">
            <MoveLeft size={20} />
            <span>Pagina precedente</span>
          </button>
        </div>

        {/* Suggerimento di ricerca */}
        <div className="pt-8">
          <div className="inline-flex items-center gap-2 px-4 py-3 rounded-lg
            bg-light-surface-container dark:bg-dark-surface-container">
            <Search size={20} className="text-light-on-surface-variant dark:text-dark-on-surface-variant" />
            <span className="text-light-on-surface-variant dark:text-dark-on-surface-variant">
              Prova a utilizzare la ricerca per trovare ciò che stai cercando
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;